/**
 * Partner-/Vertrauens-Badges.
 *
 * Offizieller IONOS-Partner-Badge. Selbst gehostet unter
 * /public/images/partners/ionos-partner.svg statt per Hotlink von IONOS,
 * weil:
 *   • die weiße IONOS-Variante (normal_white) dauerhaft 403 liefert
 *     (nicht öffentlich abrufbar),
 *   • die blaue Variante einen eigenen soliden Navy-Hintergrund mit
 *     weißem Rand hat und dadurch auf hellem UND dunklem Seiten-
 *     hintergrund gleich gut aussieht – keine Theme-Umschaltung nötig,
 *   • self-hosted immer lädt (kein Hotlink-/Referer-Risiko) und am
 *     Vercel-Edge gecacht wird.
 *
 * Der Link zeigt weiterhin aufs echte IONOS-Partnerprofil (rel=nofollow),
 * darüber ist die Partnerschaft verifizierbar.
 */

const IONOS_PROFILE =
  "https://partnernetzwerk.ionos.de/partner/dmd.studio.gmbh?origin=PartnerBadge";

export function PartnerBadges({ className }: { className?: string }) {
  return (
    <div className={className}>
      <a
        href={IONOS_PROFILE}
        target="_blank"
        rel="nofollow noopener noreferrer"
        aria-label="IONOS – Offizieller Partner: Partnerprofil ansehen (öffnet in neuem Tab)"
        className="inline-flex rounded-lg border p-2 transition-opacity duration-100 hover:opacity-90"
        // Weiße Karte FIX (nicht theme-abhängig): das Badge ist ein dunkel-
        // blauer Kasten (#0b2a63) und braucht immer einen hellen Untergrund,
        // sonst geht es im Dark-Mode im dunklen Footer unter (Kontrast 1.35).
        style={{ backgroundColor: "#ffffff", borderColor: "#E4E7EC" }}
      >
        {/* Selbst gehostetes SVG (same-origin) → plain <img>. next/image
            optimiert SVGs ohnehin nicht und bräuchte dangerouslyAllowSVG. */}
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src="/images/partners/ionos-partner.svg"
          alt="IONOS – Offizieller Partner"
          width={150}
          height={88}
          loading="lazy"
          className="h-12 w-auto"
        />
      </a>
    </div>
  );
}
